import Vue from "vue";
import { Component, Emit, Prop } from "vue-property-decorator";

import { ModalAction, RawChipItem, RawFrontendChipItem } from "./typedChips.types";

@Component
export default class TypedChipsSettingMixin extends Vue {
  @Prop() currentModel!: RawFrontendChipItem

  @Prop() action!: ModalAction

  @Prop() prefix!: string

  @Emit()
  onChipsUpdate(chips: RawChipItem) {
    return chips
  }

  processChipsValues: null | (() => void) = null
}
